//import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import '@fortawesome/fontawesome-free/css/all.css'
library.add(fas)
// Content Security Policy対策
config.autoAddCss = false;
//Vue.component('font-awesome-icon', FontAwesomeIcon)

export default (app) => {
    app.component('font-awesome-icon', FontAwesomeIcon);
}